import styled from 'styled-components';

export const TitleCardQuestion = styled.p`
    font-family: 'Roboto';
    font-size: 20px;
    font-weight: 500;
    margin-top: 0;
`;
